// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2G9n5","colMin":"styles_colMin__3SR8W","colCheckbox":"styles_colCheckbox__Ete11"};